import { Loader2 } from "lucide-react";
import { SectionHeader } from "./section-header";
import { HistoryItem } from "./history-item";
import { PlayerResult } from "./player-result";
import { TeamResult } from "./team-result";

export const DropdownContent = ({
  query,
  isLoading,
  playerResults,
  teamResults,
  history,
  selectedIndex,
  setSelectedIndex,
  onSelect,
  onRemoveHistory,
}) => {
  const hasQuery = query.trim().length > 0;

  if (isLoading) {
    return (
      <div className="p-4 flex justify-center">
        <Loader2 className="w-5 h-5 text-blue-500 animate-spin" />
      </div>
    );
  }

  if (!hasQuery && history.length > 0) {
    return (
      <div className="max-h-80 overflow-y-auto">
        <SectionHeader>Recent</SectionHeader>
        {history.map((item, i) => (
          <HistoryItem
            key={item.id}
            item={item}
            selected={selectedIndex === i}
            onSelect={onSelect}
            onRemove={onRemoveHistory}
            onMouseEnter={() => setSelectedIndex(i)}
          />
        ))}
      </div>
    );
  }

  if (!hasQuery) return null;

  if (playerResults.length === 0 && teamResults.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500 text-sm">
        No players or teams found
      </div>
    );
  }

  let globalIdx = 0;

  return (
    <div className="max-h-80 overflow-y-auto">
      {playerResults.length > 0 && (
        <>
          <SectionHeader>Players</SectionHeader>
          {playerResults.map((player) => {
            const idx = globalIdx++;
            return (
              <PlayerResult
                key={player.player_id}
                player={player}
                selected={selectedIndex === idx}
                onSelect={onSelect}
                onMouseEnter={() => setSelectedIndex(idx)}
              />
            );
          })}
        </>
      )}
      {teamResults.length > 0 && (
        <>
          <SectionHeader>Teams</SectionHeader>
          {teamResults.map((team) => {
            const idx = globalIdx++;
            return (
              <TeamResult
                key={team.team_id}
                team={team}
                selected={selectedIndex === idx}
                onSelect={onSelect}
                onMouseEnter={() => setSelectedIndex(idx)}
              />
            );
          })}
        </>
      )}
    </div>
  );
};
